module.exports = __webpack_public_path__ + "img/live_bgimg.0cffe619.png";